<template>
  <EmptyResourceNotification v-if="resource && resource.children_ids.length < 1" :resource="resource" />
  <div v-else class="accordion container">
    <AccordionItem
      v-for="(child, index) in resource.children"
      :key="child.id"
      :is-open="index === openItem"
      :resource="child"
      @click.native="toggleItem(index)"
    />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import AccordionItem from 'beisheim/components/blocks/accordion-item'
import EmptyResourceNotification from 'beisheim/components/elements/empty-resource-notification'

export default {
  components: {
    AccordionItem,
    EmptyResourceNotification
  },
  mixins: [ editable ],
  data () {
    return {
      openItem: false
    }
  },
  methods: {
    toggleItem (index) {
      if (this.openItem === index) {
        this.openItem = false
      } else {
        this.openItem = index
      }
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/scale';
@import 'beisheim/scss/grid';

.accordion {
  @include grid-spacing(padding-left, 2);
  @include grid-spacing(padding-right, 3);
  margin: scale(8) auto scale(20) auto;
}
</style>
